import { Component, Input, Output, EventEmitter } from '@angular/core';
import { OrderProvider } from '../../providers/order/order';

@Component({
  selector: 'orderby-filter',
  templateUrl: 'orderby-filter.html'
})
export class OrderbyFilterComponent {

  @Input() filterType: string;
  @Output() changed: EventEmitter<string> = new EventEmitter();

  constructor(private orderService: OrderProvider) {
    this.orderService.getSelectedOrder().then(selectedOrder => {
      if (selectedOrder == null) {
        this.orderService.setSelectedOrder("asc");
      }
      else {
        this.filterType = selectedOrder;
      }
    });
    this.orderService.currentOrder.subscribe(selectedOrder => {
      this.filterType = selectedOrder;
    });
  }

  filterChange(){
    this.orderService.setSelectedOrder(this.filterType);
    this.changed.emit(this.filterType);
  }

}


// WEBPACK FOOTER //
// ./src/components/orderby-filter/orderby-filter.ts